// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__xwZ7o","lds-ripple":"Loader_lds-ripple__l9LhO","center":"Loader_center__VOkg9"};